import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        paddingVertical: 12,
        paddingHorizontal: 8,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        right: 0,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 48,
    },
    slider: { height: 100, paddingVertical: 16 },
    icon: { marginBottom: 0 },
});

export default styles;
